/**
 * Copy - Centered, Large module
 *
 * Simple copy module, with centered text.
 */

// Deps
import { FelaComponent, createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { fluid } from "~/styleguide/utils";
import { fonts, textStyles } from "~/styleguide/typography";

export default function CopyThreeColumns({ block }) {
    const { heading, content, anchor_id } = block;

    if (!heading && !content && !content.length) return null;

    return (
        <Container id={anchor_id} className="module-copy-three-columns">
            {heading && (
                <Copy
                    dangerouslySetInnerHTML={{
                        __html: heading
                    }}
                />
            )}

            <Columns>
                {content.map((entry, index) => {
                    return (
                        <Content key={index} count={content.length}>
                            {/* Bolded title */}
                            {entry.title && (
                                <Title extend={titleStyles}>
                                    <span dangerouslySetInnerHTML={{ __html: entry.title }} />
                                </Title>
                            )}

                            {/* Description */}
                            {entry.description && (
                                <FelaComponent
                                    style={textStyles.paragraphSmall}
                                    as="p"
                                >
                                    <span dangerouslySetInnerHTML={{ __html: entry.description }} />
                                </FelaComponent>
                            )}
                        </Content>
                    );
                })}
            </Columns>
        </Container>
    );
}

const Container = createComponent(
    () => ({
        textAlign: "center",
        extend: [
            fluid("paddingH", gutters.default),
            fluid("paddingV", gutters.vertical)
        ]
    }),
    "div",
    ["id"]
);

const Copy = createComponent(
    () => ({
        ...fonts.logicalBold,
        maxWidth: 750,
        marginH: "auto",
        lineHeight: "1.4",
        extend: [
            fluid("font-size", { max: 24, min: 18 }),
            fluid("margin-bottom", { max: 50, min: 30 })
        ]
    }),
    "p",
    ["dangerouslySetInnerHTML"]
);

const Title = createComponent(() => textStyles.paragraphSmall, "p");

const titleStyles = {
    fontWeight: "bold",
    display: "block"
};

const Columns = createComponent(() => ({
    display: "flex",
    flexWrap: "wrap",
    marginH: "auto",
    maxWidth: 1000
}));

const Content = createComponent(({ count }) => ({
    width: "33.333%",
    textAlign: "left",

    grid: {
        cols: "3",
        margins: "80",
        length: count,
        bottomMargin: 30
    }
}));
